import { arrayToById } from "redux/normalize";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as api from "api/api";
import { loginReset } from "redux/slice/authentication";
import { LeadLastActivityResource } from "api/resource/lead-last-activity";

export interface LeadLastSearchAgentChatsState {
    loading?: boolean;
    error?: string | null;
    byId: {
        [key: number]: LeadLastActivityResource;
    };
};

const initialState: LeadLastSearchAgentChatsState = {
    byId: {},
};

const fetchLeadLastSearchAgentChats = createAsyncThunk("leadLastSearchAgentChats/fetchLeadLastSearchAgentChats", async (payload, thunkAPI) => {
	thunkAPI.dispatch(leadLastSearchAgentChatsLoading());
	const result = api.getLeadLastSearchAgentChats();
	result
		.then((leadLastSearchAgentChats) => thunkAPI.dispatch(leadLastSearchAgentChatsLoaded(leadLastSearchAgentChats)))
		.catch(error => thunkAPI.dispatch(leadLastSearchAgentChatsFailed(error)));
	return result;
});

export const leadLastSearchAgentChatsSlice = createSlice({
	name: "leadLastSearchAgentChats",
	initialState,
	reducers: {
		leadLastSearchAgentChatsLoading: (state) => {
			state.loading = true;
		},
		leadLastSearchAgentChatsLoaded: (state, action: PayloadAction< LeadLastActivityResource[]>) => {
			state.loading = false;
			state.error = null;
			state.byId = arrayToById(action.payload, "id");
		},
		leadLastSearchAgentChatsFailed: (state, action: PayloadAction<any>) => {
			state.loading = false;
			state.error = action.payload.message;
		},
		default: (state) => {
            return state;
        }
    },
    extraReducers(builder) {
		builder.addCase(loginReset, (state) => {
			return {
				...initialState,
				error: state.error,
			};
		});
    }
});

export const { leadLastSearchAgentChatsLoading, leadLastSearchAgentChatsLoaded, leadLastSearchAgentChatsFailed } = leadLastSearchAgentChatsSlice.actions;
export { fetchLeadLastSearchAgentChats };